import { useState, useMemo, useCallback } from 'react';
import { Drawer, message } from 'antd';

import DataTable, { DragHandle } from '../../components/DataTable';
import Operator from '../../components/Operator';
import SaveButton from '../../components/SaveButton';
import EditItem from './EditItem';
import ReviewItem from './ReviewItem';
import GenerateItem from './GenerateItem';
import EditItemDrawer from './EditItemDrawer';

import request from '@/request';

export default function Items({ items, event, refreshItems }) {
  const [item, setItem] = useState(null);
  const [editItemDrawerVisible, setEditItemDrawerVisible] = useState(false);
  const [reviewItemDrawerVisible, setReviewItemDrawerVisible] = useState(false);
  const [generateItemDrawerVisible, setGenerateItemDrawerVisible] =
    useState(false);

  const [selections, setSelections] = useState([]);

  const handleSortSubmit = useCallback(
    async (newData) => {
      try {
        await request.post('/events/item/order', {
          eventId: event.id,
          itemIds: newData.map((item) => item.id),
        });
        message.success('排序已更新');
        refreshItems();
      } catch {
        message.error('排序更新失败');
      }
    },
    [event.id, refreshItems]
  );

  const showEditItemDrawer = () => {
    setItem(null);
    setEditItemDrawerVisible(true);
  };

  const closeEditItemDrawer = () => {
    setEditItemDrawerVisible(false);
    setItem(null);
  };

  const showReviewItemDrawer = (record) => {
    setItem(record);
    setReviewItemDrawerVisible(true);
  };

  const closeReviewItemDrawer = () => {
    setReviewItemDrawerVisible(false);
    setItem(null);
  };

  const showGenerateItemDrawer = () => {
    setSelections([]);
    setGenerateItemDrawerVisible(true);
  };

  const closeGenerateItemDrawer = () => {
    setGenerateItemDrawerVisible(false);
  };

  const generateItemSave = useCallback(async () => {
    setGenerateItemDrawerVisible(false);
    const cItems = [];
    selections.forEach((row, rowIdx) => {
      row.forEach((selected, colIdx) => {
        if (selected) {
          cItems.push({
            typeId: rowIdx + 1,
            groupId: colIdx + 1,
          });
        }
      });
    });
    await request.post('/events/items/smart', {
      eventId: event.id,
      items: cItems,
    });
    refreshItems();
  }, [event.id, selections, refreshItems]);

  const columns = useMemo(() => {
    const data = [
      { key: 'sort', align: 'center', render: () => <DragHandle /> },
      {
        title: '排序',
        dataIndex: 'order',
        render: (_, record, index) => index + 1,
      },
      {
        title: '项目名称',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => (
          <a
            className="text-blue-600 hover:text-blue-700 cursor-pointer"
            onClick={() => showReviewItemDrawer(record)}
          >
            {text}
          </a>
        ),
      },
      {
        title: '组别',
        dataIndex: 'groupName',
        key: 'groupName',
      },
      {
        title: '报名费（RMB）',
        dataIndex: 'applyPrice',
        key: 'applyPrice',
        render: (fee) => <span className="text-slate-700">¥{fee}</span>,
      },
      {
        title: '报名人数',
        key: 'applyRange',
        render: (v, record) =>
          `${v.minApply}至${v.maxApply}${record.minPlayer !== null ? '队' : '人'}`,
      },
      {
        title: '队伍人数',
        key: 'teamRange',
        render: (record) =>
          record.minPlayer ? `${record.minPlayer}至${record.maxPlayer}人` : '',
      },
      {
        title: '操作',
        key: 'action',
        align: 'right',
        render: (_, record) => (
          <Operator
            onEdit={() => {
              setEditItemDrawerVisible(true);
              setItem(record);
            }}
            onRemove={refreshItems}
            removeAPI={event.reviewStatus !== 2 ? '/events/item' : ''}
            title="赛项"
            record={record}
          />
        ),
      },
    ];
    return data;
  }, [event.reviewStatus, refreshItems]);

  return (
    <div className="space-y-5">
      {[0, 1, 2].includes(event.status) && (
        <div className="flex items-center gap-3 justify-end">
          <button
            type="button"
            className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-4 py-2 rounded-md shadow-sm transition-shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
            onClick={showEditItemDrawer}
          >
            + 智能添加
          </button>
          {/* <button
            type="button"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white text-sm font-medium px-4 py-2 rounded-md shadow-sm transition-all duration-200 cursor-pointer"
            onClick={showGenerateItemDrawer}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13 10V3L4 14h7v7l9-11h-7z"
              />
            </svg>
            智能添加
          </button> */}
        </div>
      )}

      <DataTable
        columns={columns}
        list={items}
        pagination={false}
        onSortSubmit={handleSortSubmit}
        components={{ body: { row: (props) => <tr {...props} /> } }}
      />

      {/* <Drawer
        title="编辑竞赛项目"
        size={660}
        onClose={closeEditItemDrawer}
        open={editItemDrawerVisible}
      >
        <EditItem
          items={items}
          item={item}
          event={event}
          onClose={() => {
            closeEditItemDrawer();
            refreshItems();
            setItem({});
          }}
        />
      </Drawer> */}

      <EditItemDrawer
        key={editItemDrawerVisible ? 'editItemShow' : 'editItemHidden'}
        onClose={closeEditItemDrawer}
        open={editItemDrawerVisible}
        items={items}
        item={item}
        event={event}
      />

      <Drawer
        title="项目详情"
        size={660}
        onClose={closeReviewItemDrawer}
        open={reviewItemDrawerVisible}
      >
        <ReviewItem item={item} />
      </Drawer>

      {/* <Drawer
        title="智能赛项模版（可多选）"
        size={650}
        onClose={closeGenerateItemDrawer}
        open={generateItemDrawerVisible}
        extra={<SaveButton text="添加" onSave={generateItemSave} />}
      >
        <GenerateItem
          key={generateItemDrawerVisible ? 'open' : 'closed'}
          items={items}
          onChange={setSelections}
        />
      </Drawer> */}
    </div>
  );
}
